import { EXPERIENCES } from "../constants";
import { motion } from "framer-motion";

const Experiences = () => {
  return (
    <div className="border-b border-brown-800 pb-12 pt-16">
      <motion.h2
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: -100 }}
        transition={{ duration: 1 }}
        className="my-12 py-12 text-center text-4xl text-brown-accent font-medium font-cormorant"
      >
        {" "}
        My Experiences
      </motion.h2>

      <div>
        {EXPERIENCES.map((experience, index) => (
          <div key={index} className="mb-8 flex flex-wrap lg:justify-center">
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: -50 }}
              transition={{ duration: 1 }}
              className="w-full lg:w-1/4"
            >
              <p className="mb-2  text-brown-muted">{experience.year}</p>
            </motion.div>
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 50 }}
              transition={{ duration: 1 }}
              className="w-full max-w-xl lg:w-3/4 flex flex-wrap"
            >
              <h6 className="mb-2 font-semibold text-brown-cream text-lg">
                {experience.role} - {""}
                <span className=" text-lg text-brown-accent">
                  {experience.company}
                </span>{" "}
              </h6>
              <p className="mb-4 text-brown-muted">{experience.description}</p>
              {experience.technologies.map((tech, index) => (
                <span
                  key={index}
                  className=" mr-2 mt-4 rounded bg-brown-800 px-2 py-1 text-sm font-medium text-brown-accent"
                >
                  {tech}
                </span>
              ))}
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experiences;
